if (!customElements.get('product-toast')) {
  class ProductToast extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.Initialize();
    }

    Initialize() {
      let self = this;
      self.addEventListener('open:toast', self.OpenToast);
      self.addEventListener('close:toast', self.CloseToast);

      let $closeButton = self.querySelector('[data-product-toast-close]');
      if ($closeButton) {
        $closeButton.addEventListener('click', self.CloseToast.bind(self));
      }

      document.addEventListener('wk:wishlist:add:scuccess', (e) => {
        self.OpenToast();

        setTimeout(() => {
          self.CloseToast();
        }, 5000);
      });

      document.addEventListener('wk:open:wishlist-drawer', (e) => {
        self.CloseToast();
      });
    }

    OpenToast() {
      this.removeAttribute('hidden');
    }

    CloseToast() {
      this.setAttribute('hidden', '');
    }
  }

  customElements.define('product-toast', ProductToast);
}